module.exports = "/_next/static/images/Destinations-4dc8a9abe4af41777740be9333aabe2c.webp";